import { render } from "./DetailedProjectTabs.vue?vue&type=template&id=0d8fb634"
import script from "./DetailedProjectTabs.vue?vue&type=script&lang=js"
export * from "./DetailedProjectTabs.vue?vue&type=script&lang=js"

import "./DetailedProjectTabs.vue?vue&type=style&index=0&id=0d8fb634&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__